module.exports = __webpack_public_path__ + "img/down.095d70ef.svg";